import * as Loaders from 'react-spinners';

const Loader = ({ type = 'ClipLoader', ...rest }) => {
  const Component = Loaders[type];
  return <Component {...rest} />;
};

export default Loader;
